module.exports = __webpack_public_path__ + "img/150.1f1adf89.jpg";